import type { ReactElement } from "react";

import type { ContactEntryType, ContactSearchEntry } from "../../../types/common";
import ContactDetailsList from "../../ContactDetails/ContactDetailsList";
import ContactDetailsOverlayStateWithTermsGuard from "../../ContactDetailsOverlayStateWithTermsGuard/ContactDetailsOverlayStateWithTermsGuard";

import { StyledBaseCell } from "./styles";

export interface IContactDetailsCellProps {
    isLoading: boolean;
    isContactsAvailabilityReadonly: boolean;
    isActionPanelActivated: boolean;
    isDataCreditsEnabled: boolean;
    remainingRevealQuota: number;
    contactsCost: number;
    isContactIdNotRevealed: boolean;
    rowData: ContactSearchEntry;
    onReveal: VoidFunction;
    onApprove?: () => Promise<unknown> | undefined;
    onCopy?: (entryType: ContactEntryType) => void;
    dataAutomationPrefix?: string;
}

const ContactDetailsCell = ({
    isLoading,
    isContactsAvailabilityReadonly,
    isActionPanelActivated,
    isDataCreditsEnabled,
    remainingRevealQuota,
    contactsCost,
    isContactIdNotRevealed,
    rowData,
    onReveal,
    onApprove,
    onCopy,
    dataAutomationPrefix,
}: IContactDetailsCellProps): ReactElement => {
    const { isRevealed, hasValidEmails, hasDirectPhoneNumbers, hasMobilePhoneNumbers } = rowData;

    const hasDetailsToReveal = hasValidEmails || hasDirectPhoneNumbers || hasMobilePhoneNumbers;

    return (
        <StyledBaseCell
            dataAutomation={dataAutomationPrefix ? `${dataAutomationPrefix}-details` : "contacts-table.cell.details"}
        >
            <ContactDetailsList
                rowData={rowData}
                onCopy={onCopy}
                dataAutomationPrefix={dataAutomationPrefix}
            />

            <ContactDetailsOverlayStateWithTermsGuard
                isLoading={isLoading}
                isHideActions={isActionPanelActivated}
                isDataCreditsEnabled={isDataCreditsEnabled}
                isRevealed={isRevealed}
                hasDetailsToReveal={hasDetailsToReveal}
                isContactsAvailabilityReadonly={isContactsAvailabilityReadonly}
                remainingRevealQuota={remainingRevealQuota}
                contactsCost={contactsCost}
                isContactIdNotRevealed={isContactIdNotRevealed}
                onReveal={onReveal}
                onApprove={onApprove}
            />
        </StyledBaseCell>
    );
};

export default ContactDetailsCell;
